import React from "react";
import { motion } from "framer-motion";
import {
  GraduationCap,
  BookOpen,
  Users,
  Clock,
  CheckCircle,
  ArrowRight,
} from "lucide-react";
const Courses = () => {
  const courses = [
    {
      title: "Bachelor of Arts",
      shortName: "B.A.",
      duration: "3 Years",
      description:
        "A complete undergraduate program designed to build strong knowledge in arts, humanities, language, society, and general studies.",
      subjects: [
        "Hindi Literature",
        "English Literature",
        "Political Science",
        "Sociology",
        "History",
        "Education",
      ],
    },
    {
      title: "Bachelor of Commerce",
      shortName: "B.Com",
      duration: "3 Years",
      description:
        "A career-focused undergraduate program that helps students understand commerce, accounting, business, finance, and management concepts.",
      subjects: [
        "Accounting",
        "Business Studies",
        "Economics",
        "Business Law",
        "Finance",
        "Management",
      ],
    },
  ];
  return (
    <section className="w-full bg-[#F6F8FC] py-12 md:py-16 overflow-hidden">
      <div className="w-full px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center max-w-3xl mx-auto mb-10"
          >
            <span className="inline-flex items-center gap-2 bg-[#FFD700] text-[#071A52] px-5 py-2 rounded-full text-xs font-black uppercase tracking-wide mb-4 shadow">
              <BookOpen size={15} />
              Our Courses
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-[#071A52] leading-tight">
              Courses Offered
            </h2>
            <div className="w-24 h-1.5 bg-[#FFD700] rounded-full mx-auto mt-4 mb-4"></div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              Pt. Shrinivas Dwivedi Mahavidyalaya offers undergraduate courses
              focused on quality education, academic growth, and career
              development.
            </p>
          </motion.div>
          <div className="grid md:grid-cols-2 gap-8">
            {courses.map((course, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 35 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.12 }}
                viewport={{ once: true }}
                className="group relative bg-white rounded-[28px] shadow-xl border border-gray-100 overflow-hidden hover:-translate-y-2 hover:shadow-2xl transition-all duration-300"
              >
                <div className="h-2 bg-gradient-to-r from-[#071A52] via-[#0B1F5C] to-[#FFD700]"></div>
                <div className="p-6 md:p-8">
                  <div className="flex items-start justify-between gap-5 mb-6">
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 rounded-2xl bg-[#071A52] text-[#FFD700] flex items-center justify-center shadow-md group-hover:bg-[#FFD700] group-hover:text-[#071A52] transition-all duration-300">
                        <GraduationCap size={32} />
                      </div>
                      <div>
                        <h3 className="text-2xl font-black text-[#071A52]">
                          {course.shortName}
                        </h3>
                        <p className="text-sm font-semibold text-gray-600 mt-1">
                          {course.title}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 bg-[#F6F8FC] px-4 py-2 rounded-full text-[#071A52] text-xs font-black">
                      <Clock size={14} />
                      {course.duration}
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
                    {course.description}
                  </p>
                  <div className="mb-6">
                    <h4 className="text-[#071A52] font-black mb-4">
                      Major Subjects
                    </h4>
                    <div className="grid sm:grid-cols-2 gap-3">
                      {course.subjects.map((subject, i) => (
                        <div
                          key={i}
                          className="flex items-center gap-2 bg-[#F8FAFC] border border-gray-100 rounded-xl px-3 py-2"
                        >
                          <CheckCircle size={16} className="text-[#D4A017]" />
                          <span className="text-sm font-semibold text-gray-700">
                            {subject}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 bg-[#071A52] rounded-2xl p-5">
                    <div className="flex items-center gap-3 text-white">
                      <Users size={22} className="text-[#FFD700]" />
                      <span className="text-sm font-semibold">
                        Admission Open
                      </span>
                    </div>
                    <button className="inline-flex items-center justify-center gap-2 bg-[#FFD700] text-[#071A52] px-5 py-2.5 rounded-xl text-sm font-black hover:bg-white transition-all">
                      Apply Now
                      <ArrowRight size={16} />
                    </button>
                  </div>
                </div>
                <div className="absolute -right-12 -bottom-12 w-36 h-36 bg-[#FFD700]/10 rounded-full"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Courses;